import { ng } from '@uirouter/angularjs/lib/angular';
import { StateParams, StateService } from '@uirouter/core';
import * as angular from 'angular';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../app.common/modules/common/services/popup.service';
import { AccountService } from '../../account/account.service';
import { RetailerService } from '../../api/retailer.service';
import { ExtraItemModel, FoodPreferenceItem } from '../../core';
import { MenuPreference } from '../../core';
import { IRetailerRootScope } from '../../core/models';
import { FoodPreferenceService } from '../../foodPreferences/foodPreference.service';
import { ScheduleService } from '../../menus/schedule.service';
import { ExtrasService } from '../extras.service';
import { IExtraItemRequest, IFoodPreferenceItem } from '../models/models';

class AddOrEditExtraItem implements ng.IController {
    public static $inject = [
        '$rootScope',
        '$scope',
        '$stateParams',
        '$state',
        'notificationService',
        'popupService',
        'accountService',
        'retailerService',
        'foodPreferenceService',
        'scheduleService',
        'extrasService',
        '$uibModal',
        '$translate'
    ];
    public idParam: string;
    public allergenTitle: string;
    public preferenceTitle: string;
    public allAllergens: MenuPreference[];
    public allPreference: MenuPreference[];
    public commonAllergenDescription: string;
    public commonPreferenceDescription: string;
    public isEatInGreaterTakeaway: boolean;
    private waiting = false;
    private extraEditorForm: ng.IFormController;
    private isNew: boolean;
    private showTitleError: boolean = false;
    private titleErrorText: string = '';
    private currencyCssClass: string;
    private item: ExtraItemModel = {
        Title: null,
        Price: null,
        SKU: null,
        Allergens: [],
        FoodPreferences: [],
        ImageID: null,
        CurrencyCode: null,
        CurrencySign: null,
        VAT: null,
        InsidePrice: null,
        InsideVAT: null,
    } as ExtraItemModel;

    private foodPreferences: IFoodPreferenceItem[];
    private foodAllergens: IFoodPreferenceItem[];

    constructor(
        $rootScope: IRetailerRootScope,
        private $scope: angular.IScope,
        public $stateParams: StateParams,
        private $state: StateService,
        private notificationService: NotificationService,
        private popupService: PopupService,
        private accountService: AccountService,
        private retailerService: RetailerService,
        private foodPreferencesService: FoodPreferenceService,
        private scheduleService: ScheduleService,
        private extrasService: ExtrasService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $translate: angular.translate.ITranslateService,
    ) {}

    public async $onInit() {
        this.titleErrorText = this.$translate.instant('extra_editor_title_error');
        this.idParam = this.$stateParams.id;
        this.isNew = !this.idParam;
        await this.getData();
        if (this.idParam) {
            await this.loadExtraItem();
            this.prepaidData();
        } else {
            this.setCurrency();
        }
        this.setAddImageWatcher();
        await this.loadFoodPreferenceInfo();
    }

    public async loadExtraItem() {
        try {
            this.item = await this.extrasService.getExtraItem(this.idParam);
            this.currencyCssClass = this.getCurrencyCssClass(this.item.CurrencySign);
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }

    public prepaidData() {
        this.item.FoodPreferences.forEach((x) => {
           const item = this.foodPreferences.find((i) => i.ID === x.ID);
           item.IsSelected = true;
        });

        this.item.Allergens.forEach((x) => {
            const item = this.foodAllergens.find((i) => i.ID === x.ID);
            item.IsSelected = true;
        });
    }

    public setCurrency() {
        this.item.CurrencySign = this.accountService.userData.currencySign;
        this.currencyCssClass = this.getCurrencyCssClass(this.item.CurrencySign);
    }

    public getCurrencyCssClass(sign: string): string {
        switch (sign) {
            case '£': return 'withPound';
            case 'kr': return 'withKrona';
            case '$': return 'withDollar';
            case '€': return 'withEuro';
            case 'د.إ': return 'withDirham';
            default: return '';
        }
    }

    public getImage(item: any) {
        return this.extrasService.getExtraImageUrl(item.ImageID.toString());
    }

    public async saveData() {
        if (this.item.InsidePrice && this.item.Price) {
            this.isEatInGreaterTakeaway = (Number(this.item.Price) !== Number(this.item.InsidePrice)) &&
            (Number(this.item.InsidePrice) < Number(this.item.Price));
        } else {
            this.isEatInGreaterTakeaway = false;
        }
        if (!this.item.Title || this.isEatInGreaterTakeaway) {
            return ;
        }
        this.notificationService.showWaitingMessage();
        this.waiting = true;

        this.showTitleError = false;
        try {
             await this.extrasService.checkExtraAlreadyExist(this.item.Title, this.item.ID);
        } catch (error) {
            this.showTitleError = true;
            this.waiting = false;
            this.notificationService.clearAll();
            return;
        }

        const requestModel = this.getRequestModel();
        try {
            await this.extrasService.createOrUpdateExtra(requestModel, this.idParam);
            this.notificationService.clearAll();
            this.notificationService.showSuccessMessage();
            this.$state.go('app.extras.active');
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        finally {
            this.waiting = false;
        }
    }

    public async cancel() {
        this.$state.go('app.extras.active');
    }

    public clearEatInTakeawayError() {
        this.isEatInGreaterTakeaway = false;
    }

    public async addImage() {
        try {
             const imageID = await this.$uibModal.open({
                component: 'jispPayAvatar',
                scope: this.$scope.$new(true),
                resolve: {
                    avatarId: () => this.item.ImageID,
                    title: () => this.$translate.instant('extra_photo'),
                    getUrl: () =>
                        this.item.ImageID == null ||
                        this.extrasService.getExtraImageUrl(
                            this.item.ImageID.toString()
                        ),
                    saveUrl: () => this.extrasService.saveExtraImageUrl()
                },
                backdrop: 'static'
            }).result;
             if (imageID) {
                this.item.ImageID = imageID;
            }
        } catch (error) {
            return;
        }
    }

    public loadFoodPreferenceInfo = async () => {
        this.allergenTitle = this.$translate.instant('allergens_title');
        this.preferenceTitle = this.$translate.instant('foodPreference_title');
        this.allAllergens = await this.foodPreferencesService.getAllergens();
        this.allPreference = await this.foodPreferencesService.getFoodPreference();
        this.commonAllergenDescription = this.bindDescription(
            this.allAllergens
        );
        this.commonPreferenceDescription = this.bindDescription(
            this.allPreference
        );
    }

    private bindDescription(preference: MenuPreference[]): string {
        let result = '';
        result += '<table class="preferenceDescription">';
        let counter = 0;
        preference
            .sort((a, b) =>
                a.Description.length > b.Description.length
                    ? -1
                    : b.Description.length > a.Description.length
                    ? 1
                    : 0
            )
            .forEach((c) => {
                if (counter % 3 === 0) {
                    result += '<tr>';
                }

                result +=
                    '<td><h3>' +
                    c.Name +
                    '</h3>' +
                    c.Description +
                    '</br></td>';
                counter++;

                if (counter % 3 === 0) {
                    result += '</tr>';
                }
            });
        result += '</table>';
        return result;
    }

    private getRequestModel(): IExtraItemRequest {
        return {
            Title: this.item.Title,
            Price: this.item.Price,
            SKU: this.item.SKU,
            AllergenIDs: this.foodAllergens.filter((x) => x.IsSelected).map((x) => x.ID),
            FoodPreferenceIDs: this.foodPreferences.filter((x) => x.IsSelected).map((x) => x.ID),
            ImageID: this.item.ImageID,
            VAT: this.item.Price ? this.item.VAT : null,
            InsidePrice: this.item.Price ? this.item.InsidePrice : null,
            InsideVAT: this.item.InsidePrice && this.item.Price ? this.item.InsideVAT : null
        };
    }

    private setAddImageWatcher() {
        this.$scope.$watch(() => this.item.ImageID, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.extraEditorForm.$setDirty();
            }
        });
    }

    private async getData() {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            this.foodPreferences = await this.extrasService.getFoodPreferences();
            this.foodAllergens = await this.extrasService.getAllergens();
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

}

angular.module('naut').component('addOrEditExtraItem', {
    template: require('./add-or-edit-extra-item.component.html'),
    controller: AddOrEditExtraItem,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/extras/add-or-edit-extra-item/add-or-edit-extra-item.component.ts